import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page event" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "break" }, null, -1)
const _hoisted_4 = {
  id: "left-panel",
  class: "left-panel"
}
const _hoisted_5 = { class: "right-panel" }
const _hoisted_6 = { class: "content-border" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sakura = _resolveComponent("Sakura")!
  const _component_EventFloatingButtons = _resolveComponent("EventFloatingButtons")!
  const _component_NavbarProgress = _resolveComponent("NavbarProgress")!
  const _component_ThreeFullorder = _resolveComponent("ThreeFullorder")!
  const _component_RenderingFullorder = _resolveComponent("RenderingFullorder")!
  const _component_RenderingViewButtons = _resolveComponent("RenderingViewButtons")!
  const _component_Progressbar = _resolveComponent("Progressbar")!
  const _component_FavoriteButton = _resolveComponent("FavoriteButton")!
  const _component_ModeButton = _resolveComponent("ModeButton")!
  const _component_Instruction = _resolveComponent("Instruction")!
  const _component_NavbarSlider = _resolveComponent("NavbarSlider")!
  const _component_FullorderForm = _resolveComponent("FullorderForm")!
  const _component_FavoriteDialog = _resolveComponent("FavoriteDialog")!
  const _component_BagsizeDialog = _resolveComponent("BagsizeDialog")!
  const _component_CopyLinkDialog = _resolveComponent("CopyLinkDialog")!
  const _component_MobileBagtypeDialog = _resolveComponent("MobileBagtypeDialog")!
  const _component_MobileGreenboardDialog = _resolveComponent("MobileGreenboardDialog")!
  const _component_MobileNameDialog = _resolveComponent("MobileNameDialog")!
  const _component_Overlay = _resolveComponent("Overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isSakuraVisible)
      ? (_openBlock(), _createBlock(_component_Sakura, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_EventFloatingButtons),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_NavbarProgress),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_ctx.useThreeMode)
            ? (_openBlock(), _createBlock(_component_ThreeFullorder, { key: 0 }))
            : _createCommentVNode("", true),
          (!_ctx.useThreeMode)
            ? (_openBlock(), _createBlock(_component_RenderingFullorder, { key: 1 }))
            : _createCommentVNode("", true),
          (!_ctx.useThreeMode)
            ? (_openBlock(), _createBlock(_component_RenderingViewButtons, { key: 2 }))
            : _createCommentVNode("", true),
          _createVNode(_component_Progressbar),
          _createVNode(_component_FavoriteButton, { class: "hide-mobile" }),
          _createVNode(_component_ModeButton, { isMobile: false }),
          _createVNode(_component_Instruction)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_NavbarSlider, {
              desktopTabs: _ctx.desktopTabs,
              mobileTabs: _ctx.mobileTabs
            }, null, 8, ["desktopTabs", "mobileTabs"]),
            _createVNode(_component_FullorderForm),
            _createVNode(_component_FavoriteDialog),
            _createVNode(_component_BagsizeDialog, { class: "hide-mobile" }),
            _createVNode(_component_CopyLinkDialog, {
              isMobile: false,
              class: "hide-mobile"
            })
          ])
        ]),
        _createVNode(_component_BagsizeDialog, { class: "hide-desktop" }),
        _createVNode(_component_MobileBagtypeDialog, { class: "hide-desktop" }),
        _createVNode(_component_MobileGreenboardDialog, { class: "hide-desktop" }),
        _createVNode(_component_MobileNameDialog, { class: "hide-desktop" }),
        _createVNode(_component_CopyLinkDialog, {
          isMobile: true,
          class: "hide-desktop"
        })
      ])
    ]),
    _createVNode(_component_Overlay)
  ], 64))
}